<template>
  <button @click.stop="$emit('click')"></button>
</template>

<script>
export default {
  props: ['type']

}
</script>

<style lang="scss" scoped>
button {
  background-color: transparent;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  &::before {
    content: '';
    display: inline-block;
    width: 27.34px;
    height: 27.34px;
    background-color: #FF6B6B;
    mask-image: url(./svg/btn/del1.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: 25px 27.71px;
  }
}
</style>
